<template>
    <div class="vehicles-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box d-block d-sm-flex justify-content-sm-between">
                    <h4
                        class="page-title align-self-center mr-2"
                        id="page_title"
                        >
                        Vehicle Search
                    </h4>
                    <div class="d-sm-flex d-block align-items-center mt-3 mt-sm-0">
                        <div class="d-flex mr-3 align-items-center">
                            <p class="m-0 pr-2 listings-only-title">My Dealership Listings Only</p>
                            <input
                                @change="onDealershipListingToggle"
                                checked
                                id="switch1"
                                switch="none"
                                type="checkbox"
                                v-model="filters.dealership_listing_only"
                            />
                            <label
                                class="m-0"
                                data-off-label="No"
                                data-on-label="Yes"
                                for="switch1"
                            />
                        </div>
                        <div class="position-relative mt-3 mt-sm-0">
                            <div class="input-group mt-1 mt-md-0">
                                <input
                                    v-model="filters.keyword"
                                    class="form-control"
                                    placeholder="Search by make, model and year ..."
                                    style="width: 250px; background-color: white;"
                                    type="text"
                                    >
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-primary waves-effect waves-light"
                                        type="button"
                                        @click="showListingWithSearchKeyword"
                                        >
                                        <i class="mdi mdi-magnify"/>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div class="mb-5">
                <vehicle-carousel
                    :bodies="bodies"
                    :status="status"
                    :filters="filters"
                    @showListingWithBody="showListingWithBody"
                    />
            </div>
            <div :class="show_listing && is_large_screen ? 'd-lg-flex' : ''">
                <div :class="{
                    'col-sm-4 col-md-3' : show_listing && is_large_screen,
                    'col-sm-12' : (!show_listing) && !is_large_screen,
                    'l-gray' : show_listing && is_large_screen
                }"
                     class="px-0"
                >
                    <search-vehicle
                        v-if="searchVehicleReady"
                        :should-clear-filters="should_clear_filters"
                        @showListing="onShowListing"
                        @updateFilter="onUpdateFilter"
                        @clearFilter="onClearFilter"
                        ref="searchVehicle"
                    />
                </div>
                <div :class="{
                    'col-sm-8 col-md-9' : is_large_screen
                }"
                     v-if="show_listing"
                     class="results-container"
                >
                    <p class="my-3 ml-2" v-if="!vehicles.data.length && vehicles.meta.fetched">No listing found...</p>
                    <p class="my-3 ml-2" v-if="!vehicles.meta.fetched && vehicles.meta.loading">Loading...</p>
                    <loading
                        :active.sync="vehicles.meta.loading"
                        :height="30"
                        :is-full-page="false"
                        :width="30"
                    />
                    <div class="row px-2">
                        <div
                            :class="{ 'col-4' : !is_mobile, 'col-12': is_mobile }"
                            class="px-1 rounded"
                            v-for="vehicle in vehicles.data"
                        >
                            <vehicle-item
                                :key="vehicle.id"
                                :vehicle="vehicle"
                            />
                        </div>
                    </div>
                    <pagination
                        :pagination="vehicles.meta.pagination"
                        @current-change="onChangePage"
                        class="pt-2"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";

import SearchVehicle from "@/components/main/SearchVehicle";
import VehicleItem from "@/components/main/VehicleItem";
import VehicleStatus from "@/constants/vehicle-statuses";
import {filter} from "lodash";
import {HOME_NET} from "@/constants/vehicle-providers";
import VehicleMixin from '@/mixins/vehicle'
import VehicleCarousel from "@/components/main/carousel/Vehicle";
import store from "@/store";
import Actions from "@/constants/store/actions";
import {mapState} from "vuex";

const HEAVY_TRUCK_BODY_ID = 209;
const CREW_CAB_BODY_ID = 236;

const fetchVehiclesYears = async () => {
    await store.dispatch(Actions.fetch_vehicle_years)
}

const fetchVehicleMakes = async () => {
    await store.dispatch(Actions.fetch_vehicle_makes)
}

export default {
    mixins: [VehicleMixin],
    async beforeRouteEnter(to, from, next) {
        await next(async (vm) => {
            await fetchVehiclesYears();
            await fetchVehicleMakes();
            vm.initFilters(to)
        })
    },
    async beforeRouteUpdate(to, from, next) {
        await fetchVehiclesYears();
        await fetchVehicleMakes();
        next();
    },
    data() {
        return {
            HOME_NET,
            VehicleStatus,
            CREW_CAB_BODY_ID,
            HEAVY_TRUCK_BODY_ID,
                vehicles: {
                    data: [],
                    meta: {
                        fetched: false,
                        loading: false,
                        pagination: null
                    }
                },
                filters: {
                    body_id: null,
                    dealership_listing_only: false,
                    keyword: null,
                },
                body_vehicles: {
                    data: [],
                    meta: {
                        loading: false,
                        fetched: false
                    }
                },
                show_listing: false,
                should_clear_filters: false,
                status: VehicleStatus.available.value,
                status_filters: [
                    {
                        value: VehicleStatus.available.value,
                        label: 'Active'
                    },
                    {
                        value: VehicleStatus.sold.value,
                        label: 'Sold/Completed'
                    }
                ]
            }
        },
        components: {
            VehicleItem,
            SearchVehicle,
            VehicleCarousel,
        },
        computed: {
            ...mapState({
                vehicle_years: state => state.vehicle_years,
                vehicle_makes: state => state.vehicle_makes,
            }),
            bodies() {
                return _.orderBy(this.body_vehicles.data, (item) => {
                    return item.order;
                });
            },
            searchVehicleReady() {
                return this.vehicle_years.meta.fetched
                    && this.vehicle_makes.meta.fetched;
            }
        },
        created() {
            this.initBodiesVehicleCount();
        },
        methods: {
            initFilters(route) {
                this.filters.dealership_listing_only = parseInt(route.query.dealership_listing_only) === 1;
                this.status = route.query.status;
                this.filters.keyword = route.query.keyword;
            },
            initBodiesVehicleCount() {
                this.body_vehicles.meta.loading = true;
                axios.get('/web-api/get-bodies-vehicle-count')
                    .then((response) => {
                        this.body_vehicles.meta.loading = false;
                        this.body_vehicles.meta.loading = true;
                        this.body_vehicles.data = response.data;
                    });
            },
            onShowListing(page) {
                this.show_listing = true;
                this.vehicles.meta.loading = true;
                this.$refs.searchVehicle.searchVehicle(page)
                    .then((response) => {
                        this.vehicles.data = filter(response.data, (item) => {
                            return !item.hid_at || (item.hid_at && item.company_id === window.App.state.user.companies[0].id);
                        })
                        this.vehicles.meta.pagination = response.meta;
                        this.vehicles.meta.fetched = true;
                        this.vehicles.meta.loading = false;
                        VueScrollTo.scrollTo('.results-container', {offset: -150});
                    });
            },
            onChangePage(page) {
                this.$refs.searchVehicle.showListing(page)
            },
            showListingWithBody(id) {
                this.should_clear_filters = true;
                const isSameId = this.filters.body_id === id;
                this.filters.body_id = isSameId ? null : id;
                this.setFilter('body_id', this.filters.body_id);
            },
            showListingWithSearchKeyword() {
                this.$refs.searchVehicle.handleShowListingWithSearchKeyword('keyword', this.filters.keyword);
            },
            onDealershipListingToggle() {
                this.setFilter(
                    'dealership_listing_only',
                    this.filters.dealership_listing_only
                );
            },
            setFilter(key, value) {
                this.$refs.searchVehicle.setFilter(key, value);
            },
            onUpdateFilter(filters) {
                this.filters = _.extend(this.filters, _.pick(filters, [
                    'body_id',
                    'dealership_listing_only'
                ]));
            },
            onClearFilter(isTriggered) {
                if (isTriggered) {
                    this.filters.keyword = null;
                    this.should_clear_filters = false;
                }
            },
        }
    }
</script>

<style scoped>
    .l-gray {
        background-color: #f9f9f9
    }
</style>
